import api from '../../plugins/api';

// ÐÐ°Ð³ÑÑÐ·ÐºÐ° ÑÐ¾ÑÐ¾ Ð°Ð²ÑÐ¾ Ð´Ð»Ñ Ð¾ÑÐµÐ½ÐºÐ¸ Ð·Ð°Ð»Ð¾Ð³Ð° Freedom (ÐºÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ðµ/Ð±/Ñ Ð°Ð²ÑÐ¾).
// documentType: FRONT_SIDE_IMAGE | LEFT_SIDE_IMAGE | RIGHT_SIDE_IMAGE |
//               BACK_SIDE_IMAGE | VIN_IMAGE | TECHNICAL_PASSPORT_FRONT_SIDE_IMAGE
// ÐÑÐºÐµÐ½Ð´ ÑÐºÐ»Ð°Ð´ÑÐ²Ð°ÐµÑ ÑÐ°Ð¹Ð» Ð² completed_order_documents Ð¿Ð¾Ð´ Ð½ÑÐ¶Ð½ÑÐ¼ typeId/serialNumberId,
// Ð° Ð¿ÑÐ¸ Ð²ÑÐ±Ð¾ÑÐµ Freedom Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐµÑ ÑÐ¾ÑÐ¾ Ð² Ð±Ð°Ð½Ðº Ð¼ÐµÑÐ¾Ð´Ð¾Ð¼ /upload Ð¿ÐµÑÐµÐ´ /confirm.
const ffinUploadCarPhoto = ({ appealId, documentType, file, onProgress }) => {
  const formData = new FormData();
  formData.append('appealId', appealId);
  formData.append('documentType', documentType);
  formData.append('file', file);

  return api.post('/api/bank/ffin/car-photo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: onProgress
      ? (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
          onProgress({ loaded: progressEvent.loaded, total: progressEvent.total, percent });
        }
      : undefined,
  });
};

export default ffinUploadCarPhoto;
